"use client";

import dynamic from "next/dynamic";

// Import the actual scanner from app/components
const AIPlagiarismScanner = dynamic(
  () => import("../../components/AIPlagiarismScanner"),
  {
    ssr: false,
    loading: () => (
      <div className="p-6 text-sm text-neutral-500">Loading scanner…</div>
    ),
  }
);

export default function AIPlagiarismScannerClient(props) {
  return <AIPlagiarismScanner {...props} />;
}
